import Address from '@/locations/models/address'
import Entity from '@/common/models/entity'
import { InquiryState } from '@/inquiries/models/inquiry-state'
import Pricing from '@/inquiries/models/pricing'
import moment from 'moment'
import Period from '@/common/models/periods/period'
import InquiryContact from './Inquiry-contact'

export default class Inquiry extends Entity {
  public creatorId: string = ''
  public creationDate: string = moment().format('YYYY-MM-DD')
  public takerId: string | null = null
  public state: InquiryState = InquiryState.Open
  public title: string = ''
  public description: string = ''
  public expiryDate: string = moment()
    .add(7, 'days')
    .format('YYYY-MM-DD')
  public pricing: Pricing = new Pricing()
  public hasLocation: boolean = true
  public address: Address = new Address()
  public period: Period = new Period()
  public contacts: InquiryContact[] = []
  public isCreator: boolean = false
  public creatorTitle: string = ''
  public creatorFirstName: string = ''
  public creatorLastName: string = ''
  public creatorPhoneNumber: string = ''
  public creatorEmail: string = ''
  public creatorCompanyName: string = ''
  public creatorAddress: string = ''

  constructor() {
    super()
  }

  public static copy(inq: Inquiry): Inquiry {
    var newInquiry = new Inquiry()
    newInquiry.creatorId = inq.creatorId
    newInquiry.creationDate = moment().format('YYYY-MM-DD')
    newInquiry.takerId = null
    newInquiry.state = InquiryState.Open
    newInquiry.title = inq.title
    newInquiry.description = inq.description
    newInquiry.expiryDate = inq.expiryDate
    newInquiry.pricing = inq.pricing
    newInquiry.hasLocation = inq.hasLocation
    newInquiry.address = inq.address
    newInquiry.period = inq.period
    newInquiry.contacts = []
    newInquiry.isCreator = false
    newInquiry.creatorTitle = inq.creatorTitle
    newInquiry.creatorFirstName = inq.creatorFirstName
    newInquiry.creatorLastName = inq.creatorLastName
    newInquiry.creatorPhoneNumber = inq.creatorPhoneNumber
    newInquiry.creatorEmail = inq.creatorEmail
    newInquiry.creatorCompanyName = inq.creatorCompanyName
    newInquiry.creatorAddress = inq.creatorAddress

    return newInquiry
  }
}
